export interface SnackBarState {
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarType: 'success' | 'error' | 'warning';
  showSnackbar: (
    message: string,
    type: 'success' | 'error' | 'warning'
  ) => void;
  hideSnackbar: () => void;
}

type SnackbarStateMethods = {
  updateSearch: 'updateSearch';
  showSnackbar: 'showSnackbar';
  hideSnackbar: 'hideSnackbar';
};

export const SNACKBAR_INITIAL_STATE: Omit<
  SnackBarState,
  keyof SnackbarStateMethods
> = {
  snackbarOpen: false,
  snackbarMessage: '',
  snackbarType: 'success'
};
